'use client'

import GoogleIcon from '@wiggui/ds/GoogleIcon'
import Navbar from '@wiggui/ds/Navbar'
import IconWiggot from '@wiggui/ds/IconWiggot'
import Tooltip from '@wiggui/ds/Tooltip'
import ToastProvider from '@wiggui/ds/ToastProvider'
import { ROUTES } from '../../constants'

interface MinimalistNavbarProps {
  backRoute?: string
  tooltipContent?: string
}

const WrapperCloseIcon = ({ tooltipContent }: { tooltipContent?: string }) => {
  const Icon = <GoogleIcon name="close" className="text-surface-dark" />

  if (!tooltipContent) {
    return Icon
  }

  return (
    <Tooltip placement="top-start" content={tooltipContent}>
      {Icon}
    </Tooltip>
  )
}

export const MinimalistNavbar = ({
  backRoute,
  tooltipContent
}: MinimalistNavbarProps) => {
  return (
    <>
      <Navbar className="row-span-1 col-span-full z-2 w-full bg-white items-center">
        <Navbar.Left className="flex-initial !h-[37px] flex-shrink-0 !justify-center w-fit">
          <button
            type="button"
            onClick={() => (window.location.href = ROUTES.HOME)}
          >
            <IconWiggot variant="black" />
          </button>
        </Navbar.Left>
        {backRoute && (
          <Navbar.Right>
            <Navbar.InteractionIcons
              interactionIcons={[
                {
                  hideOnMobile: false,
                  icon: <WrapperCloseIcon tooltipContent={tooltipContent} />,
                  onClick: () => (window.location.href = backRoute)
                }
              ]}
            />
          </Navbar.Right>
        )}
      </Navbar>
      <ToastProvider />
    </>
  )
}
